<template>
  <v-container fluid class="ma-0 pa-0 d-flex justify-center">
    <v-container class="ma-0 pa-0">
      <v-tabs
        fixed-tabs
        v-model="tabs_allgemeinKlassen"
        class="d-md-none mb-6"
      >
        <v-tab>Allgemein</v-tab>
        <v-tab>Klassen</v-tab>
      </v-tabs>
      <v-container class="ma-0 pa-2">
        <v-row>
          <v-col
            v-if="
              tabs_allgemeinKlassen == '0' ||
              $vuetify.breakpoint.mdAndUp
            "
          >
            <!-- Allgemein -->
            <v-container
              class="text-title text--secondary text-uppercase text-center d-none d-md-block"
            >
              Allgemein
            </v-container>
            <v-row v-if="1 === 2">
              <v-col align="center">
                <v-btn small
                  @click="trySwitchOldDB('del');"
                  :loading="loadingTrySwitchOldDB"
                >Daten in DB löschen</v-btn>
              </v-col>
              <v-col align="center">
                <v-btn
                  small
                  @click="trySwitchOldDB('add');"
                  :loading="loadingTrySwitchOldDB"
                  :disabled="
                    prop_klassen.length > 0
                  "
                >Daten aus alter APP laden</v-btn>
              </v-col>
            </v-row>
            <p
              class="text-title text--secondary"
            >
              Nutzergruppe der Eltern
            </p>
            <p
              class="text-caption text--secondary mb-0"
            >
              Nutzer, die der folgenden Nutzergruppe zugeordnet sind, werden
              als Eltern behandelt:
            </p>
            <v-select
              :items="$store.state.main.save.nutzergruppen"
              v-model="save.settings.id_nutzergruppe_eltern"
              item-value="id"
              item-text="name"
              class="pt-0"
            />
            <p
              class="text-title text--secondary"
            >
              Standardwerte
            </p>
            <p
              class="text-caption text--secondary mb-4"
            >
              Die folgenden Werte gelten für alle neu hinzugefügten Kinder:
            </p>
            <v-row>
              <v-col>
                <TimePicker
                  label="Standardbetreuungsplatz"
                  icon="mdi-clock-time-four"
                  v-model="save.settings.standardbetreuungsplatz"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TimePicker
                  label="Standardentlasszeit"
                  icon="mdi-clock-time-four"
                  v-model="save.settings.standardentlasszeit"
                />
              </v-col>
            </v-row>
            <p
              class="text-title text--secondary"
            >
              Elternbriefe: Logindaten
            </p>
            <v-text-field
              type="text"
              label="URL zur App"
              v-model="save.settings.eltern_elternbriefLogindaten_appurl"
            ></v-text-field>
            <p
              class="text-caption text--secondary mb-4"
            >
              Generierte Elternbriefe zur Weitergabe der Logindaten enthalten
              folgende Texte:
            </p>
            <v-row>
              <v-col>
                <v-textarea
                  auto-grow
                  label="Text vor den Logindaten"
                  v-model="save.settings.eltern_elternbriefLogindaten_textBeforeLogindata"
                  hint=""
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  auto-grow
                  label="Text nach den Logindaten"
                  v-model="save.settings.eltern_elternbriefLogindaten_textAfterLogindata"
                  hint=""
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="xChanged.settings">
              <v-col align="center">
                <v-btn
                small
                color="success"
                class="ml-2"
                :loading="isSaving"
                @click="trySaveSettings({ type: 'settings', data: save.settings});"
                >
                  <v-icon
                  left
                  >mdi-content-save</v-icon>
                  Änderungen Speichern
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="
              tabs_allgemeinKlassen == '1' ||
              $vuetify.breakpoint.mdAndUp
            "
          >
            <!-- Klassen -->
            <v-container
              class="text-title text--secondary text-uppercase text-center d-none d-md-block"
            >
              Klassen
            </v-container>
            <v-row>
              <v-col align="center">
                <v-dialog
                  scrollable
                  v-model="dialog_neuesSchuljahr"
                  max-width="720"
                  :persistent="neuesSchuljahrDialogGesperrt"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                    >
                      <v-icon left>mdi-swap-horizontal</v-icon>
                      Neues Schuljahr
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      <b v-if="
                        neuesSchuljahrStatus.schritt === 1
                      ">
                        Schritt 1: Neue Klassenzuweisung
                      </b>
                      <b v-if="
                        neuesSchuljahrStatus.schritt === 2
                      ">
                        Schritt 2: Elternkonten generieren
                      </b>
                      <b v-if="
                        neuesSchuljahrStatus.schritt === 3
                      ">
                        Schritt 3: Anwesenheiten zurücksetzen
                      </b>
                      <b v-if="
                        neuesSchuljahrStatus.schritt === 4
                      ">
                        Schritt 4: Vorschau und Ausführung
                      </b>
                    </v-card-title>

                    <v-card-text>
                      <!-- STUFE 1 -->
                      <div
                        v-if="neuesSchuljahrStatus.schritt === 1"
                      >
                        <v-checkbox
                          v-model="neuesSchuljahrStatus.verteileNeueKlassen"
                          label="Kinder in die nächste Klasse versetzen"
                        ></v-checkbox>
                        <template v-if="neuesSchuljahrStatus.verteileNeueKlassen">
                          <v-alert
                            v-if="neuesSchuljahrMappingPruefungAnzeigen && !neuesSchuljahrMappingVollstaendig"
                            dense
                            text
                            type="error"
                            class="mb-3"
                          >
                            Bitte wählen Sie für jede vorhandene Klasse ausdrücklich eine
                            Zielklasse oder „Kinder dieser Klasse entfernen“ aus.
                          </v-alert>
                          <p
                            class="text-caption text--secondary mb-0"
                            style="text-align:justify;"
                          >
                            In welche Klassen werden die Kinder der jeweiligen Klassen versetzt?
                            <br>
                            - Kinder werden nur bei der ausdrücklichen Auswahl
                            „Kinder dieser Klasse entfernen“ gelöscht.
                            <br>
                            - Die Kinder in Klassen, die sich selbst zugewiesen sind,
                            bleiben unberührt.
                            <br>
                            - Auf Basis der Namen der Klassen kann die Zuweisung auch automatisch
                            erfolgen. (Beispiel: Kinder der Klasse 1A werden der 2A zugewiesen.)
                          </p>
                          <v-row class="my-0 mt-2">
                            <v-col class="py-0" align="center">
                              <v-btn
                                x-small
                                @click="automatischeKlassenzuweisungBeiSchuljahreswechsel();"
                              >
                                Automatische zuweisung
                              </v-btn>
                            </v-col>
                            <v-col class="py-0" align="center">
                              <v-btn
                                x-small
                                @click="resetAutomatischeKlassenzuweisungBeiSchuljahreswechsel();"
                              >
                                Zurücksetzen
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="py-0">
                            <v-col
                              cols="6"
                              v-for="(klasse, idx) in prop_klassen"
                              :key="idx"
                            >
                              <v-select
                                :label="klasse.name"
                                :items="neuesSchuljahrKlassenZiele"
                                :value="neuesSchuljahrStatus.naechsteKlasse[klasse.id]"
                                item-text="name"
                                item-value="id"
                                :error-messages="
                                  neuesSchuljahrMappingPruefungAnzeigen
                                    && neuesSchuljahrKlasseFehlt(klasse.id)
                                    ? ['Bitte Ziel auswählen']
                                    : []
                                "
                                @change="neuesSchuljahrKlassenzielSetzen(klasse.id, $event)"
                              />
                            </v-col>
                          </v-row>
                        </template>
                      </div>
                      <!-- STUFE 2 -->
                      <div
                        v-if="neuesSchuljahrStatus.schritt === 2"
                      >
                        <v-checkbox
                          v-model="neuesSchuljahrStatus.alleElternkontenLoeschen"
                          label="Nur alle Elternkonten löschen"
                          @change="neuesSchuljahrNurElternLoeschenGeaendert($event)"
                        ></v-checkbox>
                        <p
                          v-if="neuesSchuljahrStatus.alleElternkontenLoeschen"
                          class="text-caption text--secondary mb-0"
                          style="text-align:justify;"
                        >
                          Alle Elternkonten werden gelöscht und es werden keine neuen Elternkonten
                          generiert.
                        </p>
                        <div v-else>
                          <p
                            class="text-caption text--secondary mb-0"
                            style="text-align:justify;"
                          >
                            Die Elternkonten der Kinder, die entfernt werden, werden ebenfalls
                            gelöscht, sofern ihnen kein weiteres verbleibendes Kind zugewiesen ist.
                          </p>
                          <v-checkbox
                            v-model="neuesSchuljahrStatus.fuerAlleNeueElternkonten"
                            label="Allen Kindern neue Elternkonten generieren"
                          ></v-checkbox>
                          <p
                            v-if="!neuesSchuljahrStatus.fuerAlleNeueElternkonten"
                            class="text-caption text--secondary mb-0"
                            style="text-align:justify;"
                          >
                            Für alle Kinder, denen kein Elternkonto zugewiesen ist,
                            wird ein neues Elternkonto erstellt.<br>
                            Kinder mit Geschwisterkindern, die bereits einem
                            Elternkonto zugeordnet sind, werden ebenfalls diesem
                            zugeordnet.
                          </p>
                          <p
                            v-if="neuesSchuljahrStatus.fuerAlleNeueElternkonten"
                            class="text-caption text--secondary mb-0"
                            style="text-align:justify;"
                          >
                            Es werden alle bestehenden Elternkonten gelöscht und
                            für jedes Kind neu generiert.<br>
                            ACHTUNG: Da Telefonnummern den Eltern zugewiesen sind,
                            werden diese beim Löschen der Elternkonten ebenfalls
                            gelöscht.
                          </p>
                          <p
                            class="text-caption text--secondary mb-0"
                            style="text-align:justify;"
                          >
                            Geschwisterkinder erhalten ein gemeinsames
                            Elternkonto.<br>
                            Als Nutzername für das Elternkonto wird immer der
                            Nachname des Kindes verwendet.
                            Ist bereits ein Konto mit diesem Namen vorhanden,
                            wird eine fortlaufende Ziffer angefügt.
                          </p>
                        </div>
                      </div>
                      <!-- STUFE 3 -->
                      <div
                        v-if="neuesSchuljahrStatus.schritt === 3"
                      >
                        <v-checkbox
                          v-model="neuesSchuljahrStatus.anwesenheitenZuruecksetzen"
                          label="Alle Anwesenheiten zurücksetzen"
                        ></v-checkbox>
                        <p
                          v-if="!neuesSchuljahrStatus.anwesenheitenZuruecksetzen"
                          class="text-caption text--secondary mb-0"
                          style="text-align:justify;"
                        >
                          Die Anwesenheiten bleiben bestehen.<br>
                          <br>Achten Sie dennoch darauf, nicht
                          mehr benötigte Anwesenheiten dennoch zu löschen. Dies verhindert
                          Schwierigkeiten bei der Auswertung und verkürzt die Ladezeit erheblich.
                        </p>
                        <p
                          v-if="neuesSchuljahrStatus.anwesenheitenZuruecksetzen"
                          class="text-caption text--secondary mb-0"
                          style="text-align:justify;"
                        >
                          Es werden sämtliche bestehenden Anwesenheiten restlos gelöscht.<br>
                          <br>
                          Achten Sie darauf, dass für alle benötigten Anwesenheiten unter
                          "Statistik" eine Auswertung erstellt und archiviert wurde.
                        </p>
                      </div>
                      <!-- STUFE 4 -->
                      <div
                        v-if="neuesSchuljahrStatus.schritt === 4"
                      >
                        <v-alert
                          dense
                          text
                          type="info"
                          class="mb-4"
                        >
                          Direkt vor der ersten Änderung erstellt und prüft der Server eine
                          verschlüsselte Sicherung aller betroffenen Datentabellen. Schlägt die
                          Sicherung oder eine Änderung fehl, wird der gesamte Vorgang ohne
                          Teiländerungen zurückgerollt.
                        </v-alert>
                        <v-alert
                          v-if="neuesSchuljahrFehler"
                          dense
                          text
                          type="error"
                          class="mb-4"
                        >
                          {{ neuesSchuljahrFehler }}
                        </v-alert>

                        <div
                          v-if="neuesSchuljahrPreflightLoading"
                          class="text-center py-6"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                          <p class="text-caption text--secondary mt-3 mb-0">
                            Die Auswirkungen werden serverseitig geprüft.
                          </p>
                        </div>

                        <template v-else-if="neuesSchuljahrVorschau">
                          <v-alert
                            v-if="neuesSchuljahrOperationLaeuft"
                            dense
                            text
                            type="info"
                            class="mb-4"
                          >
                            Der Schuljahreswechsel wurde gestartet. Der Status wird unter
                            derselben Vorgangskennung geprüft; die Ausführung wird nicht erneut
                            gesendet.
                          </v-alert>
                          <v-alert
                            v-else-if="neuesSchuljahrOperationAbgeschlossen"
                            dense
                            text
                            type="success"
                            class="mb-4"
                          >
                            Der Server hat den Schuljahreswechsel vollständig bestätigt.
                            Die Kinder-, Klassen- und Einstellungsdaten werden neu geladen.
                          </v-alert>

                          <div class="d-flex align-center flex-wrap mb-3">
                            <span class="text-subtitle-2 mr-2">Servervorschau</span>
                            <v-chip
                              v-if="neuesSchuljahrOperation.status"
                              x-small
                              outlined
                              :color="neuesSchuljahrStatusFarbe"
                            >
                              {{ neuesSchuljahrStatusText }}
                            </v-chip>
                          </div>

                          <v-simple-table dense class="mb-4">
                            <tbody>
                              <tr
                                v-for="zeile in neuesSchuljahrVorschauZeilen"
                                :key="zeile.key"
                              >
                                <td>{{ zeile.label }}</td>
                                <td class="text-right font-weight-bold">
                                  {{ zeile.value }}
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>

                          <v-alert
                            v-if="neuesSchuljahrVorschauZeilen.length === 0"
                            dense
                            text
                            type="error"
                          >
                            Die Servervorschau enthält keine prüfbaren Zählwerte. Der Vorgang
                            kann deshalb nicht ausgeführt werden.
                          </v-alert>

                          <v-alert
                            v-for="(warnung, index) in neuesSchuljahrWarnungen"
                            :key="`schuljahr-warnung-${index}`"
                            dense
                            text
                            type="warning"
                            class="mb-2"
                          >
                            {{ warnung }}
                          </v-alert>

                          <p
                            v-if="neuesSchuljahrOperation.id"
                            class="text-caption text--secondary mb-3"
                          >
                            Vorgangskennung: {{ neuesSchuljahrOperation.id }}
                          </p>

                          <div
                            v-if="neuesSchuljahrOperationLaeuft"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="20"
                              width="2"
                              color="primary"
                              class="mr-3"
                            ></v-progress-circular>
                            <span class="text-caption text--secondary">
                              {{ neuesSchuljahrStatusHinweis }}
                            </span>
                          </div>
                        </template>

                        <div
                          v-else
                          class="text-center py-4"
                        >
                          <p class="text-caption text--secondary">
                            Vor der Ausführung muss eine aktuelle Servervorschau geladen werden.
                          </p>
                          <v-btn
                            small
                            outlined
                            color="primary"
                            :loading="neuesSchuljahrPreflightLoading"
                            @click="neuesSchuljahrPreflight()"
                          >
                            <v-icon left>mdi-refresh</v-icon>
                            Vorschau erneut laden
                          </v-btn>
                        </div>
                      </div>
                    </v-card-text>

                    <div
                      v-if="
                        neuesSchuljahrStatus.schritt === neuesSchuljahrAnzahlSchritte
                        && !neuesSchuljahrPreflightLoading
                        && neuesSchuljahrVorschau
                        && !neuesSchuljahrAusfuehrungGestartet
                      "
                      class="px-6 py-2 flex-shrink-0"
                    >
                      <v-checkbox
                        v-model="neuesSchuljahrBestaetigt"
                        :disabled="!neuesSchuljahrVorschauGueltig"
                        class="ma-0"
                        dense
                        hide-details
                        label="Ich habe die serverseitig ermittelten Auswirkungen geprüft und möchte diesen Schuljahreswechsel verbindlich ausführen."
                      ></v-checkbox>
                    </div>

                    <v-divider></v-divider>

                    <v-card-actions class="flex-wrap">
                      <v-btn
                        text small
                        :disabled="neuesSchuljahrDialogGesperrt"
                        @click="neuesSchuljahrDialogSchliessen()"
                      >
                        Schließen
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn small color="primary"
                        class="me-1"
                        v-if="
                          neuesSchuljahrStatus.schritt > 1
                          && !neuesSchuljahrAusfuehrungGestartet
                        "
                        :disabled="neuesSchuljahrPreflightLoading"
                        @click="tryNeuesSchuljahrStepBack();"
                      >
                        zurück
                      </v-btn>
                      <v-btn small color="primary"
                        v-if="
                          neuesSchuljahrStatus.schritt < neuesSchuljahrAnzahlSchritte
                        "
                        @click="tryNeuesSchuljahrNextStep();"
                      >
                        Weiter
                      </v-btn>
                      <v-btn
                        v-if="
                          neuesSchuljahrStatus.schritt === neuesSchuljahrAnzahlSchritte
                          && !neuesSchuljahrAusfuehrungGestartet
                        "
                        small
                        color="error"
                        :disabled="!neuesSchuljahrKannAusgefuehrtWerden"
                        :loading="neuesSchuljahr_loading"
                        @click="neuesSchuljahrAusfuehren();"
                      >
                        Verbindlich ausführen
                      </v-btn>
                      <v-btn
                        v-if="
                          neuesSchuljahrStatus.schritt === neuesSchuljahrAnzahlSchritte
                          && neuesSchuljahrAusfuehrungGestartet
                          && !neuesSchuljahrOperationAbgeschlossen
                        "
                        small
                        outlined
                        color="primary"
                        :loading="neuesSchuljahrStatusLoading"
                        @click="neuesSchuljahrStatusPruefen();"
                      >
                        Status jetzt prüfen
                      </v-btn>
                      <v-btn
                        v-if="neuesSchuljahrOperationAbgeschlossen"
                        small
                        color="success"
                        @click="neuesSchuljahrDialogSchliessen();"
                      >
                        Fertig
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row v-if="neuesSchuljahrLatestLoading || neuestesWiederherstellbaresSchuljahr">
              <v-col>
                <v-progress-linear
                  v-if="neuesSchuljahrLatestLoading"
                  indeterminate
                  color="primary"
                  class="mb-2"
                ></v-progress-linear>
                <v-alert
                  v-if="neuestesWiederherstellbaresSchuljahr"
                  dense
                  text
                  type="warning"
                  class="mb-2"
                >
                  <div class="d-flex align-center flex-wrap">
                    <div class="flex-grow-1 mr-3">
                      <div class="font-weight-bold">
                        Jüngster rückgängig-fähiger Schuljahreswechsel
                      </div>
                      <div class="text-caption">
                        Abgeschlossen:
                        {{
                          datumFormatieren(
                            neuestesWiederherstellbaresSchuljahr.completedAt
                              || neuestesWiederherstellbaresSchuljahr.createdAt
                          )
                        }}
                        · Vorgang {{ neuestesWiederherstellbaresSchuljahr.id }}
                      </div>
                    </div>
                    <v-btn
                      small
                      outlined
                      color="warning"
                      class="mt-2 mt-sm-0"
                      @click="neuesSchuljahrRestoreDialogOeffnen()"
                    >
                      <v-icon left>mdi-restore</v-icon>
                      Rückgängig machen
                    </v-btn>
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <v-dialog
              v-model="dialog_neuesSchuljahrRestore"
              persistent
              max-width="560"
            >
              <v-card>
                <v-card-title class="warning white--text">
                  Schuljahreswechsel rückgängig machen?
                </v-card-title>
                <v-card-text class="pt-5">
                  <v-alert
                    v-if="neuesSchuljahrRestoreFehler"
                    dense
                    text
                    type="error"
                  >
                    {{ neuesSchuljahrRestoreFehler }}
                  </v-alert>
                  <v-alert
                    v-if="neuesSchuljahrWiederhergestellt"
                    dense
                    text
                    type="success"
                  >
                    Der Server hat die Wiederherstellung bestätigt. Die Daten werden neu geladen.
                  </v-alert>
                  <template v-else>
                    <p>
                      Der zuletzt abgeschlossene Schuljahreswechsel mit der Vorgangskennung
                      <b>{{ neuesSchuljahrRestoreOperationId }}</b> wird aus der serverseitigen
                      Sicherung wiederhergestellt.
                    </p>
                    <p class="text-caption text--secondary">
                      Während der Wiederherstellung darf kein weiterer Schuljahreswechsel
                      gestartet werden. Nach einem Verbindungsabbruch wird ausschließlich der
                      Status dieses Vorgangs geprüft. Die Wiederherstellung ist nur möglich,
                      solange die betroffenen Daten seit dem Abschluss nicht verändert wurden.
                    </p>
                    <v-checkbox
                      v-model="neuesSchuljahrRestoreBestaetigt"
                      :disabled="neuesSchuljahrRestoreLoading"
                      label="Ich möchte diesen Schuljahreswechsel verbindlich rückgängig machen."
                    ></v-checkbox>
                    <div
                      v-if="neuesSchuljahrRestoreLoading"
                      class="d-flex align-center"
                    >
                      <v-progress-circular
                        indeterminate
                        size="20"
                        width="2"
                        color="warning"
                        class="mr-3"
                      ></v-progress-circular>
                      <span class="text-caption text--secondary">
                        Die serverseitige Bestätigung wird abgewartet.
                      </span>
                    </div>
                  </template>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    :disabled="neuesSchuljahrRestoreLoading"
                    @click="neuesSchuljahrRestoreDialogSchliessen()"
                  >
                    {{ neuesSchuljahrWiederhergestellt ? 'Schließen' : 'Abbrechen' }}
                  </v-btn>
                  <v-btn
                    v-if="!neuesSchuljahrWiederhergestellt"
                    color="warning"
                    :loading="neuesSchuljahrRestoreLoading"
                    :disabled="!neuesSchuljahrRestoreBestaetigt"
                    @click="neuesSchuljahrWiederherstellen()"
                  >
                    Verbindlich wiederherstellen
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-row v-if="neuesSchuljahrElternRecoveryErlaubt">
              <v-col>
                <v-alert
                  dense
                  text
                  type="info"
                  class="mb-2"
                >
                  <div class="d-flex align-center flex-wrap">
                    <div class="flex-grow-1 mr-3">
                      <div class="font-weight-bold">
                        Elternkonten gezielt aus der letzten Sicherung retten
                      </div>
                      <div class="text-caption">
                        Stellt ausschließlich die damaligen Elternzuordnungen der noch
                        vorhandenen Kinder samt benötigten Kontodaten wieder her.
                      </div>
                    </div>
                    <v-btn
                      small
                      outlined
                      color="info"
                      class="mt-2 mt-sm-0"
                      :loading="neuesSchuljahrElternRecoveryPreviewLoading"
                      @click="neuesSchuljahrElternRecoveryDialogOeffnen()"
                    >
                      <v-icon left>mdi-account-reactivate</v-icon>
                      Sichere Vorschau
                    </v-btn>
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <v-dialog
              v-if="neuesSchuljahrElternRecoveryErlaubt"
              v-model="dialog_neuesSchuljahrElternRecovery"
              persistent
              max-width="680"
            >
              <v-card>
                <v-card-title class="info white--text">
                  Elternkonten gezielt wiederherstellen
                </v-card-title>
                <v-card-text class="pt-5">
                  <v-alert
                    dense
                    text
                    type="warning"
                  >
                    Dies ist keine vollständige Rücksetzung: Klassen, Namen,
                    Entlasszeiten, Anwesenheiten und alle sonstigen aktuellen Kind-Daten
                    bleiben unverändert. Gelöschte Kinder werden nicht zurückgeholt.
                    Bei einem Konflikt bricht der Server alles ohne Teiländerung ab.
                  </v-alert>
                  <v-alert
                    v-if="neuesSchuljahrElternRecoveryFehler"
                    dense
                    text
                    type="error"
                  >
                    {{ neuesSchuljahrElternRecoveryFehler }}
                  </v-alert>
                  <div
                    v-if="neuesSchuljahrElternRecoveryPreviewLoading"
                    class="d-flex align-center py-4"
                  >
                    <v-progress-circular
                      indeterminate
                      size="22"
                      width="2"
                      color="info"
                      class="mr-3"
                    ></v-progress-circular>
                    <span>Verschlüsselte Sicherung und aktuelle Daten werden geprüft.</span>
                  </div>
                  <template v-else-if="neuesSchuljahrElternRecoveryVorschau">
                    <v-alert
                      v-if="neuesSchuljahrElternRecoveryErfolgreich
                        || neuesSchuljahrElternRecoveryVorschau.alreadyRecovered"
                      dense
                      text
                      type="success"
                    >
                      Die selektive Eltern-Wiederherstellung ist abgeschlossen.
                    </v-alert>
                    <p class="text-caption text--secondary mb-2">
                      Sicherung vom
                      {{ datumFormatieren(neuesSchuljahrElternRecoveryVorschau.completedAt) }}
                      · Vorgang {{ neuesSchuljahrElternRecoveryVorschau.operationId }}
                    </p>
                    <v-simple-table dense class="mb-3">
                      <tbody>
                        <tr
                          v-for="zeile in neuesSchuljahrElternRecoveryVorschauZeilen"
                          :key="`eltern-recovery-${zeile.key}`"
                        >
                          <td>{{ zeile.label }}</td>
                          <td class="text-right font-weight-medium">{{ zeile.value }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <ul class="text-caption text--secondary pl-5">
                      <li
                        v-for="(warnung, index) in neuesSchuljahrElternRecoveryWarnungen"
                        :key="`eltern-recovery-warnung-${index}`"
                      >
                        {{ warnung }}
                      </li>
                    </ul>
                    <v-checkbox
                      v-if="!neuesSchuljahrElternRecoveryVorschau.alreadyRecovered
                        && !neuesSchuljahrElternRecoveryErfolgreich"
                      v-model="neuesSchuljahrElternRecoveryBestaetigt"
                      :disabled="neuesSchuljahrElternRecoveryLoading"
                      label="Ich habe die Vorschau geprüft und möchte nur diese Elternkonten und Zuordnungen verbindlich wiederherstellen."
                    ></v-checkbox>
                  </template>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    v-if="neuesSchuljahrElternRecoveryFehler
                      && !neuesSchuljahrElternRecoveryLoading"
                    text
                    color="info"
                    @click="neuesSchuljahrElternRecoveryVorschauLaden()"
                  >
                    Vorschau erneut prüfen
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    :disabled="neuesSchuljahrElternRecoveryLoading"
                    @click="neuesSchuljahrElternRecoveryDialogSchliessen()"
                  >
                    {{ neuesSchuljahrElternRecoveryErfolgreich ? 'Schließen' : 'Abbrechen' }}
                  </v-btn>
                  <v-btn
                    v-if="neuesSchuljahrElternRecoveryVorschau
                      && !neuesSchuljahrElternRecoveryVorschau.alreadyRecovered
                      && !neuesSchuljahrElternRecoveryErfolgreich"
                    color="info"
                    :loading="neuesSchuljahrElternRecoveryLoading"
                    :disabled="!neuesSchuljahrElternRecoveryBestaetigt
                      || neuesSchuljahrElternRecoveryPreviewLoading"
                    @click="neuesSchuljahrElternWiederherstellen()"
                  >
                    Auswahl verbindlich wiederherstellen
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-row>
              <v-col>
                <v-expansion-panels
                v-model="expansionPanelStatusKlassen"
                accordion
                >
                  <v-expansion-panel
                  v-for="(klasse, idx) in save.klassen" :key="idx"
                  class="grey lighten-5"
                  >
                    <v-expansion-panel-header>
                      <v-icon left style="flex:none;"></v-icon>
                      Klasse {{ klasse.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="white">
                      <v-row class="my-0">
                        <v-col class="pb-0">
                          <v-text-field
                            type="text"
                            label="Name"
                            v-model="klasse.name"
                            :rules="[
                              $store.state.main.inputValidationRules.required,
                              $store.state.main.inputValidationRules.tinytext,
                              $store.state.main.inputValidationRules.name,
                            ]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="my-0">
                        <v-col class="pb-0">
                          <p
                            v-if="klasse.id < 0"
                            class="text-title text--secondary"
                          >
                            Im eigenen Profil
                          </p>
                          <p
                            v-if="klasse.id < 0"
                            class="text-caption text--secondary"
                          >
                            Wer darf diesen Klasse in der Übersicht sehen bzw. bearbeiten?
                            <br>Achtung: Wer bearbeiten kann, kann automatisch auch sehen.
                          </p>
                          <v-checkbox
                            v-model="klasse.bedingungen.f200.sehen.alle"
                            label="Jeder kann sehen"
                          ></v-checkbox>
                          <SelectNutzergruppen
                            v-if="!klasse.bedingungen.f200.sehen.alle"
                            v-model="klasse.bedingungen.f200.sehen.gruppen"
                            label="Nur bestimmte können sehen:"
                          />
                          <v-checkbox
                            v-model="klasse.bedingungen.f200.bearbeiten.alle"
                            label="Jeder kann bearbeiten"
                          ></v-checkbox>
                          <SelectNutzergruppen
                            v-if="!klasse.bedingungen.f200.bearbeiten.alle"
                            v-model="klasse.bedingungen.f200.bearbeiten.gruppen"
                            label="Nur bestimmte können bearbeiten:"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col align="center">
                          <v-dialog
                            v-model="klasse.dialog_delKlasse"
                            width="500"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                              small
                              color="error"
                              v-bind="attrs"
                              v-on="on"
                              >
                                <v-icon left>mdi-delete</v-icon>
                                "{{ klasse.name }}" Löschen
                              </v-btn>
                            </template>

                            <v-card>
                              <v-card-title class="text-h5 grey lighten-2">
                                Sicher?
                              </v-card-title>

                              <v-card-text class="pt-4">
                                Es werden sämtliche mit dieser Klasse zusammenhängende Daten
                                und Informationen gelöscht.
                              </v-card-text>

                              <v-divider></v-divider>

                              <v-card-actions>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="klasse.dialog_delKlasse = false;"
                                >
                                  Nichts tun
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="klasseLoeschen(idx);"
                                >
                                  Ja, löschen
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <v-btn
                  small
                  @click="klasseHinzufuegen();"
                >
                  <v-icon
                  left
                  >mdi-plus-box</v-icon>
                  Klasse
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="xChanged.klassen">
              <v-col align="center">
                <v-btn
                small
                color="success"
                class="ml-2"
                :loading="isSaving"
                @click="trySaveSettings({ type: 'klassen', data: save.klassen});"
                >
                  <v-icon
                  left
                  >mdi-content-save</v-icon>
                  Änderungen Speichern
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import $ from 'jquery';
import SelectNutzergruppen from '@/components/Inputs/SelectNutzergruppen.vue';
import TimePicker from '@/components/Inputs/TimePicker.vue';

const SCHULJAHR_ENTWURF_SPEICHERKEY = 'f200_nextYear';
const SCHULJAHR_ENTWURF_SPEICHERKEY_LEGACY = 'f200_nextYeahr';
const SCHULJAHR_OPERATION_SPEICHERKEY = 'f200_nextYearOperation';
const SCHULJAHR_ANFRAGE_TIMEOUT = 30000;
const SCHULJAHR_POLLING_START = 1200;
const SCHULJAHR_POLLING_MAX = 12000;
const SCHULJAHR_OPERATION_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const SCHULJAHR_HASH = /^[0-9a-f]{64}$/i;

const SCHULJAHR_VORSCHAU_LABEL = {
  kinderGesamt: 'Kinder insgesamt',
  kinderVerschieben: 'Kinder werden versetzt',
  kinderLoeschen: 'Kinder werden entfernt',
  geschwisterZeilenBereinigen: 'Geschwister-Einträge werden bereinigt',
  geschwisterVerweiseEntfernen: 'Geschwister-Verweise werden entfernt',
  elternkontenLoeschen: 'Elternkonten werden gelöscht',
  loginsLoeschen: 'Zugehörige Benutzerkonten werden gelöscht',
  elternTelefonnummernLoeschen: 'Eltern-Telefonnummern werden gelöscht',
  kinderVonElternTrennen: 'Kinder werden von Elternkonten getrennt',
  loginEinstellungenLoeschen: 'Kontoeinstellungen werden gelöscht',
  loginParameterwerteLoeschen: 'Kontoparameter werden gelöscht',
  loginSessionsInvalidieren: 'Anmeldesitzungen werden beendet',
  neueElternkonten: 'Neue Elternkonten werden erstellt',
  kinderNeuenElternZuordnen: 'Kinder erhalten ein neues Elternkonto',
  kinderBestehendenElternZuordnen: 'Kinder erhalten ein bestehendes Elternkonto',
  kindParameterwerteLoeschen: 'Kind-Parameterwerte werden gelöscht',
  kindParameterwerteAktualisieren: 'Kind-Parameterwerte werden bereinigt',
  kindParameterIdsEntfernen: 'Kind-Verweise in Kontoparametern werden entfernt',
  anwesenheitenLoeschen: 'Anwesenheiten werden gelöscht',
  ausnahmenLoeschen: 'Ausnahmen werden gelöscht',
  regelausnahmenLoeschen: 'Regel-Ausnahmen werden gelöscht',
};

const SCHULJAHR_ELTERN_RECOVERY_LABEL = {
  aktuelleKinderMitHistorischemElternkonto: 'Aktuell vorhandene Kinder mit früherem Elternkonto',
  kinderNeuVerknuepfen: 'Kinder werden wieder mit Eltern verknüpft',
  kinderBereitsKorrektVerknuepft: 'Kinder sind bereits korrekt verknüpft',
  elternkontenWiederherstellen: 'Elternkonten werden wiederhergestellt',
  elternkontenBereitsVorhanden: 'Passende Elternkonten sind bereits vorhanden',
  loginsWiederherstellen: 'Zugangskonten werden wiederhergestellt',
  loginsBereitsVorhanden: 'Passende Zugangskonten sind bereits vorhanden',
  kontoeinstellungenWiederherstellen: 'Kontoeinstellungen werden wiederhergestellt',
  kontoparameterWiederherstellen: 'Kontoparameter werden wiederhergestellt',
  telefonnummernWiederherstellen: 'Telefonnummern werden wiederhergestellt',
  nichtMehrVorhandeneKinderUeberspringen: 'Nicht mehr vorhandene Kinder bleiben gelöscht',
  sitzungenWiederherstellen: 'Sitzungen werden wiederhergestellt',
};

function leereSchuljahrOperation() {
  return {
    id: '',
    status: '',
    createdAt: '',
    completedAt: '',
    restoredAt: '',
    restorable: false,
    started: false,
    restoreStarted: false,
    serverActive: false,
    activeAction: '',
  };
}

function standardSchuljahrStatus() {
  return {
    schritt: 1,
    naechsteKlasse: {},
    alleElternkontenLoeschen: false,
    fuerAlleNeueElternkonten: false,
    verteileNeueKlassen: true,
    anwesenheitenZuruecksetzen: true,
  };
}

export default {
  components: {
    SelectNutzergruppen,
    TimePicker,
  },
  props: {
    prop_klassen: {
      type: Array,
      default() { return []; },
    },
    prop_settings: {
      type: Object,
      default() { return {}; },
    },
  },
  data: () => ({
    loadingTrySwitchOldDB: false,
    xLoaded: {},
    xChanged: {},
    xDeleted: {},
    save: {
      klassen: [],
      settings: {},
      kinder: [],
    },
    tabs_allgemeinKlassen: 0,
    expansionPanelStatusKlassen: null,
    dialog_delKlasse: false,
    dialog_neuesSchuljahr: false,
    dialog_neuesSchuljahrRestore: false,
    dialog_neuesSchuljahrElternRecovery: false,
    neuesSchuljahr_loading: false,
    neuesSchuljahrPreflightLoading: false,
    neuesSchuljahrStatusLoading: false,
    neuesSchuljahrLatestLoading: false,
    neuesSchuljahrRestoreLoading: false,
    neuesSchuljahrElternRecoveryPreviewLoading: false,
    neuesSchuljahrElternRecoveryLoading: false,
    neuesSchuljahrMappingPruefungAnzeigen: false,
    neuesSchuljahrBestaetigt: false,
    neuesSchuljahrRestoreBestaetigt: false,
    neuesSchuljahrElternRecoveryBestaetigt: false,
    neuesSchuljahrAusfuehrungGestartet: false,
    neuesSchuljahrAusfuehrungsart: '',
    neuesSchuljahrAbschlussVerarbeitet: false,
    neuesSchuljahrVorschau: null,
    neuesSchuljahrOperation: leereSchuljahrOperation(),
    neuestesWiederherstellbaresSchuljahr: null,
    neuesSchuljahrRestoreOperationId: '',
    neuesSchuljahrElternRecoveryVorschau: null,
    neuesSchuljahrElternRecoveryErfolgreich: false,
    neuesSchuljahrFehler: '',
    neuesSchuljahrRestoreFehler: '',
    neuesSchuljahrElternRecoveryFehler: '',
    neuesSchuljahrPollTimer: null,
    neuesSchuljahrPollVersuch: 0,
    neuesSchuljahrController: [],
    neuesSchuljahrWirdZerstoert: false,
    neuesSchuljahrAnzahlSchritte: 4,
    neuesSchuljahrStatus: standardSchuljahrStatus(),
  }),
  computed: {
    neuesSchuljahrElternRecoveryErlaubt() {
      const user = this.$store.state.main.save.user || {};
      return Array.isArray(user.rechte) && user.rechte.includes('x|200|set');
    },
    neuesSchuljahrElternRecoveryVorschauZeilen() {
      const vorschau = this.neuesSchuljahrElternRecoveryVorschau || {};
      const counts = vorschau.counts && typeof vorschau.counts === 'object'
        ? vorschau.counts : {};
      return Object.keys(counts)
        .filter((key) => Object.prototype.hasOwnProperty.call(
          SCHULJAHR_ELTERN_RECOVERY_LABEL,
          key,
        ))
        .map((key) => ({
          key,
          label: SCHULJAHR_ELTERN_RECOVERY_LABEL[key],
          value: Number(counts[key]) || 0,
        }));
    },
    neuesSchuljahrElternRecoveryWarnungen() {
      const vorschau = this.neuesSchuljahrElternRecoveryVorschau || {};
      return Array.isArray(vorschau.warnings)
        ? vorschau.warnings.map((warnung) => String(warnung)) : [];
    },
    isSaving: { // Databinding mit vuex state
      get() {
        return this.$store.state.main.isSaving;
      },
      set(value) {
        this.$store.commit('main/switchIsSaving', value);
      },
    },
    neuesSchuljahrKlassenZiele() {
      return [
        { id: 0, name: 'Kinder dieser Klasse entfernen' },
        ...this.prop_klassen.map((klasse) => ({
          id: klasse.id,
          name: klasse.name,
        })),
      ];
    },
    neuesSchuljahrMappingVollstaendig() {
      if (!this.neuesSchuljahrStatus.verteileNeueKlassen) return true;
      return this.prop_klassen.every(
        (klasse) => !this.neuesSchuljahrKlasseFehlt(klasse.id),
      );
    },
    neuesSchuljahrVorschauZeilen() {
      const vorschau = this.neuesSchuljahrVorschau || {};
      const zaehler = vorschau.counts && typeof vorschau.counts === 'object'
        ? vorschau.counts : vorschau;
      const ignorierteFelder = [
        'stateHash', 'warnings', 'warnungen', 'counts', 'klassen', 'classTransitions',
      ];
      return Object.keys(zaehler)
        .filter((key) => !ignorierteFelder.includes(key))
        .filter((key) => {
          const wert = zaehler[key];
          return typeof wert === 'number'
            || (typeof wert === 'string' && wert.trim() !== '' && !Number.isNaN(Number(wert)));
        })
        .map((key) => ({
          key,
          label: this.schuljahrVorschauLabel(key),
          value: Number(zaehler[key]),
        }));
    },
    neuesSchuljahrWarnungen() {
      const vorschau = this.neuesSchuljahrVorschau || {};
      const warnungen = Array.isArray(vorschau.warnings)
        ? vorschau.warnings : (Array.isArray(vorschau.warnungen) ? vorschau.warnungen : []);
      return warnungen.map((warnung) => {
        if (warnung && typeof warnung === 'object') {
          return String(warnung.message || warnung.text || warnung.code || 'Unbekannte Warnung');
        }
        return String(warnung);
      });
    },
    neuesSchuljahrVorschauGueltig() {
      return Boolean(
        this.neuesSchuljahrVorschau
        && String(this.neuesSchuljahrVorschau.stateHash || '')
        && this.neuesSchuljahrVorschauZeilen.length > 0
        && this.neuesSchuljahrOperation.id,
      );
    },
    neuesSchuljahrKannAusgefuehrtWerden() {
      return this.neuesSchuljahrVorschauGueltig
        && this.neuesSchuljahrBestaetigt
        && !this.neuesSchuljahr_loading
        && !this.neuesSchuljahrAusfuehrungGestartet;
    },
    neuesSchuljahrOperationAbgeschlossen() {
      return this.neuesSchuljahrAusfuehrungsart === 'execute'
        && this.neuesSchuljahrOperation.status === 'completed';
    },
    neuesSchuljahrWiederhergestellt() {
      return this.neuesSchuljahrAusfuehrungsart === 'restore'
        && this.neuesSchuljahrOperation.status === 'restored';
    },
    neuesSchuljahrOperationLaeuft() {
      if (!this.neuesSchuljahrAusfuehrungGestartet) return false;
      return !['completed', 'restored', 'failed', 'error', 'rejected', 'cancelled']
        .includes(this.neuesSchuljahrOperation.status);
    },
    neuesSchuljahrDialogGesperrt() {
      return this.neuesSchuljahrAusfuehrungsart === 'execute'
        && this.neuesSchuljahrOperationLaeuft;
    },
    neuesSchuljahrStatusText() {
      const texte = {
        prepared: 'Vorschau geprüft',
        pending: 'Wartet',
        queued: 'Eingeplant',
        running: 'Wird ausgeführt',
        processing: 'Wird ausgeführt',
        completed: 'Abgeschlossen',
        restored: 'Wiederhergestellt',
        failed: 'Fehlgeschlagen',
        error: 'Fehler',
        rejected: 'Abgelehnt',
        cancelled: 'Abgebrochen',
      };
      return texte[this.neuesSchuljahrOperation.status]
        || this.neuesSchuljahrOperation.status
        || 'Unbekannt';
    },
    neuesSchuljahrStatusFarbe() {
      if (this.neuesSchuljahrOperationAbgeschlossen || this.neuesSchuljahrWiederhergestellt) {
        return 'success';
      }
      if (['failed', 'error', 'rejected', 'cancelled']
        .includes(this.neuesSchuljahrOperation.status)) return 'error';
      return this.neuesSchuljahrAusfuehrungGestartet ? 'primary' : 'info';
    },
    neuesSchuljahrStatusHinweis() {
      if (this.neuesSchuljahrStatusLoading) return 'Der aktuelle Serverstatus wird geladen.';
      if (this.neuesSchuljahrFehler) return this.neuesSchuljahrFehler;
      return 'Die nächste Statusprüfung erfolgt automatisch.';
    },
  },
  watch: {
    prop_klassen: {
      handler() {
        this.datenLaden();
      },
      deep: true,
    },
    prop_settings: {
      handler() {
        this.datenLaden();
      },
      deep: true,
    },
    dialog_neuesSchuljahr(geoeffnet) {
      if (geoeffnet) this.neuesSchuljahrDialogGeoeffnet();
    },
    neuesSchuljahrStatus: {
      handler() {
        if (!this.neuesSchuljahrWirdZerstoert
          && !this.neuesSchuljahrOperationAbgeschlossen
          && !this.neuesSchuljahrWiederhergestellt) {
          this.neuesSchuljahrEntwurfSpeichern();
        }
      },
      deep: true,
    },
    save: {
      handler() {
        /*
          Wenn ein Datenobjekt lokal (und nicht durch Laden) verändert wurde
        */
        if (JSON.stringify(this.save.klassen) !== JSON.stringify(this.xLoaded.klassen)) {
          this.xChanged.klassen = true;
        } else {
          this.xChanged.klassen = false;
        }
        if (JSON.stringify(this.save.settings) !== JSON.stringify(this.xLoaded.settings)) {
          this.xChanged.settings = true;
        } else {
          this.xChanged.settings = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    async trySwitchOldDB(type) {
      this.loadingTrySwitchOldDB = true;
      this.$store.commit('main/switchIsSaving', false);
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/200/200/switchOldDB.php?func=getData`,
        type: 'post',
        data: {
          code: this.$store.state.login.session.code,
          type,
        },
        success: () => {
        },
        error: () => {
          // Einstellungen konnten nicht geladen werden
          this.$store.commit('main/alert', {
            typ: 'error',
            text: 'Die Einstellungen konnten nicht gespeichert werden. Bitte die Netzwerkverbindung prüfen.',
          }, { root: true });
        },
        complete: () => {
          this.$store.commit('main/switchIsSaving', false);
          this.loadingTrySwitchOldDB = false;
        },
      });
    },
    datenLaden() {
      /*
        Wenn neue Daten übergeben wurden,
        prüfe ob diese sich von den zuletzt geladenen unterscheiden.
        Wenn ja, überschreibe die aktuellen Daten mit den neu übergebenen Daten.
      */
      let anythingUpdated = false;
      if (JSON.stringify(this.prop_klassen) !== JSON.stringify(this.xLoaded.klassen)) {
        this.save.klassen = JSON.parse(JSON.stringify(this.prop_klassen));
        this.xLoaded.klassen = JSON.parse(JSON.stringify(this.prop_klassen));
        anythingUpdated = true;
      }
      if (JSON.stringify(this.prop_settings) !== JSON.stringify(this.xLoaded.settings)) {
        this.save.settings = JSON.parse(JSON.stringify(this.prop_settings));
        this.xLoaded.settings = JSON.parse(JSON.stringify(this.prop_settings));
        anythingUpdated = true;
      }
      if (anythingUpdated) {
        this.expansionPanelStatusKlassen = null;
      }
    },
    klasseHinzufuegen() {
      this.save.klassen.push({
        id: '',
        name: 'Neu',
        bedingungen: {
          f200: {
            sehen: {
              alle: true,
              gruppen: [],
            },
            bearbeiten: {
              alle: true,
              gruppen: [],
            },
          },
        },
      });
      this.expansionPanelStatusKlassen = this.save.klassen.length - 1;
    },
    klasseLoeschen(idx) {
      if (this.save.klassen[idx].id) {
        this.xDeleted.klassen.push(this.save.klassen[idx].id);
      }
      this.save.klassen.splice(idx, 1);
      this.expansionPanelStatusKlassen = null;
    },
    async trySaveSettings(dataToSave) {
      this.$emit('saveSettings', { dataToSave, loaded: this.xLoaded, deleted: this.xDeleted });
    },
    schuljahrVorschauLabel(key) {
      if (SCHULJAHR_VORSCHAU_LABEL[key]) return SCHULJAHR_VORSCHAU_LABEL[key];
      const text = String(key)
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ');
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    neuesSchuljahrKlasseFehlt(idKlasse) {
      const zuweisungen = this.neuesSchuljahrStatus.naechsteKlasse || {};
      if (!Object.prototype.hasOwnProperty.call(zuweisungen, idKlasse)) return true;
      const ziel = String(zuweisungen[idKlasse]);
      return ziel !== '0'
        && !this.prop_klassen.some((klasse) => String(klasse.id) === ziel);
    },
    neuesSchuljahrKlassenzielSetzen(idKlasse, idZielklasse) {
      this.$set(this.neuesSchuljahrStatus.naechsteKlasse, idKlasse, idZielklasse);
      this.neuesSchuljahrEntwurfSpeichern();
    },
    neuesSchuljahrNurElternLoeschenGeaendert(aktiv) {
      if (aktiv) this.neuesSchuljahrStatus.fuerAlleNeueElternkonten = false;
      this.neuesSchuljahrEntwurfSpeichern();
    },
    neuesSchuljahrNutzdaten() {
      return {
        naechsteKlasse: JSON.parse(JSON.stringify(
          this.neuesSchuljahrStatus.naechsteKlasse || {},
        )),
        alleElternkontenLoeschen: this.neuesSchuljahrStatus.alleElternkontenLoeschen === true,
        fuerAlleNeueElternkonten: this.neuesSchuljahrStatus.fuerAlleNeueElternkonten === true,
        verteileNeueKlassen: this.neuesSchuljahrStatus.verteileNeueKlassen === true,
        anwesenheitenZuruecksetzen:
          this.neuesSchuljahrStatus.anwesenheitenZuruecksetzen === true,
      };
    },
    neuesSchuljahrEntwurfSpeichern() {
      try {
        window.localStorage.setItem(
          SCHULJAHR_ENTWURF_SPEICHERKEY,
          JSON.stringify(this.neuesSchuljahrStatus),
        );
        window.localStorage.removeItem(SCHULJAHR_ENTWURF_SPEICHERKEY_LEGACY);
        return true;
      } catch (error) {
        return false;
      }
    },
    neuesSchuljahrEntwurfLaden() {
      let gespeichert = null;
      let ausLegacyKey = false;
      try {
        gespeichert = window.localStorage.getItem(SCHULJAHR_ENTWURF_SPEICHERKEY);
        if (!gespeichert) {
          gespeichert = window.localStorage.getItem(SCHULJAHR_ENTWURF_SPEICHERKEY_LEGACY);
          ausLegacyKey = Boolean(gespeichert);
        }
        if (!gespeichert) return;
        const entwurf = JSON.parse(gespeichert);
        if (!entwurf || typeof entwurf !== 'object') return;
        const schritt = Math.min(
          this.neuesSchuljahrAnzahlSchritte,
          Math.max(1, Number(entwurf.schritt) || 1),
        );
        this.neuesSchuljahrStatus = {
          ...standardSchuljahrStatus(),
          ...entwurf,
          schritt,
          naechsteKlasse: entwurf.naechsteKlasse
            && typeof entwurf.naechsteKlasse === 'object'
            ? entwurf.naechsteKlasse : {},
        };
        if (this.neuesSchuljahrStatus.alleElternkontenLoeschen) {
          this.neuesSchuljahrStatus.fuerAlleNeueElternkonten = false;
        }
        if (ausLegacyKey) this.neuesSchuljahrEntwurfSpeichern();
      } catch (error) {
        this.neuesSchuljahrStatus = standardSchuljahrStatus();
      }
    },
    neuesSchuljahrOperationSpeichern() {
      if (!SCHULJAHR_OPERATION_ID.test(this.neuesSchuljahrOperation.id)) return false;
      try {
        window.localStorage.setItem(SCHULJAHR_OPERATION_SPEICHERKEY, JSON.stringify({
          operationId: this.neuesSchuljahrOperation.id,
          operation: this.neuesSchuljahrOperation,
          mode: this.neuesSchuljahrAusfuehrungsart || 'execute',
          executionStarted: this.neuesSchuljahrAusfuehrungGestartet,
          payload: this.neuesSchuljahrNutzdaten(),
          preview: this.neuesSchuljahrVorschau,
          updatedAt: Date.now(),
        }));
        return true;
      } catch (error) {
        return false;
      }
    },
    neuesSchuljahrOperationLoeschen() {
      try {
        window.localStorage.removeItem(SCHULJAHR_OPERATION_SPEICHERKEY);
      } catch (error) {
        // Der Serverstatus bleibt maßgeblich, auch wenn Storage nicht verfügbar ist.
      }
    },
    neuesSchuljahrOperationWiederaufnehmen() {
      let gespeichert;
      try {
        gespeichert = JSON.parse(
          window.localStorage.getItem(SCHULJAHR_OPERATION_SPEICHERKEY),
        );
      } catch (error) {
        gespeichert = null;
      }
      if (!gespeichert || !SCHULJAHR_OPERATION_ID.test(String(gespeichert.operationId || ''))) {
        this.neuesSchuljahrOperationLoeschen();
        return;
      }
      if (gespeichert.executionStarted !== true) {
        if (gespeichert.payload && typeof gespeichert.payload === 'object') {
          this.neuesSchuljahrStatus = {
            ...standardSchuljahrStatus(),
            ...gespeichert.payload,
            schritt: Math.max(1, this.neuesSchuljahrAnzahlSchritte - 1),
          };
        } else {
          this.neuesSchuljahrStatus.schritt = Math.max(
            1,
            this.neuesSchuljahrAnzahlSchritte - 1,
          );
        }
        this.neuesSchuljahrVorschau = null;
        this.neuesSchuljahrOperation = leereSchuljahrOperation();
        this.neuesSchuljahrAusfuehrungsart = '';
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahrBestaetigt = false;
        this.neuesSchuljahrOperationLoeschen();
        this.neuesSchuljahrEntwurfSpeichern();
        return;
      }
      this.neuesSchuljahrOperation = this.neuesSchuljahrOperationNormalisieren(
        gespeichert.operation,
        gespeichert.operationId,
      );
      this.neuesSchuljahrVorschau = gespeichert.preview
        && typeof gespeichert.preview === 'object' ? gespeichert.preview : null;
      this.neuesSchuljahrAusfuehrungsart = gespeichert.mode === 'restore'
        ? 'restore' : 'execute';
      this.neuesSchuljahrAusfuehrungGestartet = true;
      if (gespeichert.payload && typeof gespeichert.payload === 'object') {
        this.neuesSchuljahrStatus = {
          ...standardSchuljahrStatus(),
          ...gespeichert.payload,
          schritt: this.neuesSchuljahrAnzahlSchritte,
        };
      }
      if (this.neuesSchuljahrAusfuehrungsart === 'restore') {
        this.neuesSchuljahrRestoreOperationId = this.neuesSchuljahrOperation.id;
        this.neuesSchuljahrRestoreLoading = true;
        this.dialog_neuesSchuljahrRestore = true;
      } else {
        this.dialog_neuesSchuljahr = true;
      }
      this.$nextTick(() => this.neuesSchuljahrStatusPruefen());
    },
    neuesSchuljahrOperationIdErzeugen() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        const werte = new Uint8Array(16);
        window.crypto.getRandomValues(werte);
        werte[6] = (werte[6] & 0x0f) | 0x40;
        werte[8] = (werte[8] & 0x3f) | 0x80;
        const hex = Array.from(werte).map((wert) => wert.toString(16).padStart(2, '0'));
        return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}`
          + `-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}`
          + `-${hex.slice(10, 16).join('')}`;
      }
      return '';
    },
    neuesSchuljahrOperationNormalisieren(operation, fallbackId = '') {
      const quelle = operation && typeof operation === 'object' ? operation : {};
      const istWahr = (wert) => wert === true || wert === 1 || wert === '1';
      const aktiveAktion = ['execute', 'restore'].includes(String(quelle.activeAction || ''))
        ? String(quelle.activeAction) : '';
      return {
        ...leereSchuljahrOperation(),
        ...quelle,
        id: String(quelle.id || fallbackId || ''),
        status: String(quelle.status || '').toLowerCase(),
        createdAt: String(quelle.createdAt || ''),
        completedAt: String(quelle.completedAt || ''),
        restoredAt: String(quelle.restoredAt || ''),
        restorable: istWahr(quelle.restorable),
        started: istWahr(quelle.started),
        restoreStarted: istWahr(quelle.restoreStarted),
        serverActive: istWahr(quelle.serverActive),
        activeAction: aktiveAktion,
      };
    },
    neuesSchuljahrServerFehler(ergebnis, fallback) {
      if (ergebnis && ergebnis.validationErrors
        && typeof ergebnis.validationErrors === 'object') {
        const meldungen = Object.values(ergebnis.validationErrors)
          .reduce((alle, wert) => alle.concat(Array.isArray(wert) ? wert : [wert]), [])
          .filter(Boolean)
          .map((wert) => String(wert).trim())
          .filter((wert, index, alle) => wert && alle.indexOf(wert) === index);
        if (meldungen.length > 0) {
          const hauptmeldung = ergebnis.message ? String(ergebnis.message).trim() : '';
          return hauptmeldung && !meldungen.includes(hauptmeldung)
            ? `${hauptmeldung} ${meldungen.join(' ')}`
            : meldungen.join(' ');
        }
      }
      if (ergebnis && ergebnis.message) return String(ergebnis.message);
      return fallback;
    },
    neuesSchuljahrControllerEntfernen(controller) {
      this.neuesSchuljahrController = this.neuesSchuljahrController
        .filter((eintrag) => eintrag !== controller);
    },
    async neuesSchuljahrApiAnfrage(
      action,
      operationId = '',
      mitNutzdaten = false,
      zusatzfelder = {},
    ) {
      const formular = new FormData();
      formular.append('code', this.$store.state.login.session.code);
      formular.append('action', action);
      if (operationId) formular.append('operation_id', operationId);
      if (mitNutzdaten) {
        formular.append('neuesSchuljahrStatus', JSON.stringify(this.neuesSchuljahrNutzdaten()));
      }
      Object.keys(zusatzfelder).forEach((key) => {
        const wert = zusatzfelder[key];
        if (wert !== undefined && wert !== null) formular.append(key, String(wert));
      });
      if (['execute', 'restore', 'recoverParents'].includes(action)) {
        formular.append('confirmed', '1');
      }

      const controller = typeof AbortController !== 'undefined'
        ? new AbortController() : null;
      if (controller) this.neuesSchuljahrController.push(controller);
      const timeoutMarker = {};
      let timeoutId = null;
      let zeitUeberschritten = false;
      const timeoutAnfrage = new Promise((resolve) => {
        timeoutId = window.setTimeout(() => {
          zeitUeberschritten = true;
          resolve(timeoutMarker);
          if (controller) controller.abort();
        }, SCHULJAHR_ANFRAGE_TIMEOUT);
      });

      try {
        const serverAnfrage = fetch(
          `${process.env.VUE_APP_API_HOST}/200/200/?func=neuesSchuljahr`,
          {
            method: 'POST',
            body: formular,
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: controller ? controller.signal : undefined,
          },
        );
        const response = await Promise.race([serverAnfrage, timeoutAnfrage]);
        if (response === timeoutMarker) {
          const fehler = new Error('Die Serveranfrage hat das Zeitlimit überschritten.');
          fehler.istTimeout = true;
          throw fehler;
        }
        let ergebnis;
        try {
          ergebnis = await response.json();
        } catch (error) {
          throw new Error('Der Server hat keine gültige JSON-Antwort geliefert.');
        }
        if (ergebnis && ergebnis.status === 'accessError') {
          this.$store.commit('login/backendErrorSession');
          throw new Error('Die Sitzung ist abgelaufen.');
        }
        if (!response.ok || !ergebnis || ergebnis.status !== 'success') {
          const fehler = new Error(this.neuesSchuljahrServerFehler(
            ergebnis,
            'Der Schuljahreswechsel konnte nicht verarbeitet werden.',
          ));
          fehler.serverAntwort = ergebnis;
          throw fehler;
        }
        this.$emit('server-erreichbar');
        return ergebnis;
      } catch (error) {
        if (zeitUeberschritten && !error.istTimeout) {
          const fehler = new Error('Die Serveranfrage hat das Zeitlimit überschritten.');
          fehler.istTimeout = true;
          throw fehler;
        }
        throw error;
      } finally {
        if (timeoutId !== null) window.clearTimeout(timeoutId);
        if (controller) this.neuesSchuljahrControllerEntfernen(controller);
      }
    },
    neuesSchuljahrAntwortUebernehmen(ergebnis, erwarteteId) {
      if (!ergebnis || !ergebnis.operation || typeof ergebnis.operation !== 'object') {
        throw new Error('Der Server hat keinen vollständigen Vorgangsstatus geliefert.');
      }
      const operation = this.neuesSchuljahrOperationNormalisieren(
        ergebnis.operation,
        erwarteteId,
      );
      if (!SCHULJAHR_OPERATION_ID.test(operation.id) || operation.id !== erwarteteId) {
        throw new Error('Die Vorgangskennung der Serverantwort ist ungültig.');
      }
      this.neuesSchuljahrOperation = operation;
      if (ergebnis.preview && typeof ergebnis.preview === 'object') {
        this.neuesSchuljahrVorschau = ergebnis.preview;
      }
      this.neuesSchuljahrOperationSpeichern();
      return operation;
    },
    async tryNeuesSchuljahrStepBack() {
      if (this.neuesSchuljahrAusfuehrungGestartet) return;
      if (this.neuesSchuljahrStatus.schritt === this.neuesSchuljahrAnzahlSchritte) {
        this.neuesSchuljahrVorschauZuruecksetzen();
      }
      this.neuesSchuljahrStatus.schritt = Math.max(1, this.neuesSchuljahrStatus.schritt - 1);
      this.neuesSchuljahrEntwurfSpeichern();
    },
    async tryNeuesSchuljahrNextStep() {
      if (this.neuesSchuljahrStatus.schritt === 1
        && !this.neuesSchuljahrMappingVollstaendig) {
        this.neuesSchuljahrMappingPruefungAnzeigen = true;
        this.neuesSchuljahrFehler = 'Die Klassenzuweisung ist noch nicht vollständig.';
        return;
      }
      this.neuesSchuljahrFehler = '';
      if (this.neuesSchuljahrStatus.schritt >= this.neuesSchuljahrAnzahlSchritte) return;
      this.neuesSchuljahrStatus.schritt += 1;
      this.neuesSchuljahrEntwurfSpeichern();
      if (this.neuesSchuljahrStatus.schritt === this.neuesSchuljahrAnzahlSchritte) {
        await this.neuesSchuljahrPreflight();
      }
    },
    neuesSchuljahrVorschauZuruecksetzen() {
      this.neuesSchuljahrPollingStoppen();
      this.neuesSchuljahrBestaetigt = false;
      this.neuesSchuljahrVorschau = null;
      this.neuesSchuljahrOperation = leereSchuljahrOperation();
      this.neuesSchuljahrAusfuehrungsart = '';
      this.neuesSchuljahrFehler = '';
      this.neuesSchuljahrOperationLoeschen();
    },
    async neuesSchuljahrPreflight() {
      if (this.neuesSchuljahrAusfuehrungGestartet || this.neuesSchuljahrPreflightLoading) return;
      if (!this.neuesSchuljahrMappingVollstaendig) {
        this.neuesSchuljahrStatus.schritt = 1;
        this.neuesSchuljahrMappingPruefungAnzeigen = true;
        this.neuesSchuljahrFehler = 'Die Klassenzuweisung ist noch nicht vollständig.';
        return;
      }
      this.neuesSchuljahrVorschau = null;
      this.neuesSchuljahrBestaetigt = false;
      this.neuesSchuljahrFehler = '';
      this.neuesSchuljahrAusfuehrungsart = 'execute';
      const operationId = this.neuesSchuljahrOperation.id
        || this.neuesSchuljahrOperationIdErzeugen();
      if (!SCHULJAHR_OPERATION_ID.test(operationId)) {
        this.neuesSchuljahrFehler = 'Dieser Browser kann keine sichere Vorgangskennung erzeugen. '
          + 'Bitte verwenden Sie einen aktuellen Browser.';
        return;
      }
      this.neuesSchuljahrOperation = {
        ...leereSchuljahrOperation(),
        id: operationId,
        status: 'prepared',
      };
      if (!this.neuesSchuljahrOperationSpeichern()) {
        this.neuesSchuljahrFehler = 'Der sichere Wiederaufnahmestatus konnte nicht im Browser '
          + 'gespeichert werden. Der Vorgang wurde nicht gestartet.';
        return;
      }
      this.neuesSchuljahrPreflightLoading = true;
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage('preflight', operationId, true);
        if (this.neuesSchuljahrWirdZerstoert) return;
        this.neuesSchuljahrAntwortUebernehmen(ergebnis, operationId);
        if (!ergebnis.preview || typeof ergebnis.preview !== 'object'
          || !String(ergebnis.preview.stateHash || '')) {
          throw new Error('Die Servervorschau enthält keinen gültigen Datenstand.');
        }
        if (!this.neuesSchuljahrVorschauGueltig) {
          throw new Error('Die Servervorschau enthält keine vollständigen Zählwerte.');
        }
        this.neuesSchuljahrOperationSpeichern();
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        this.neuesSchuljahrFehler = error.message
          || 'Die Auswirkungen konnten nicht geprüft werden.';
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) this.neuesSchuljahrPreflightLoading = false;
      }
    },
    async neuesSchuljahrAusfuehren() {
      if (!this.neuesSchuljahrKannAusgefuehrtWerden) return;
      const operationId = this.neuesSchuljahrOperation.id;
      this.neuesSchuljahrAusfuehrungGestartet = true;
      this.neuesSchuljahrAusfuehrungsart = 'execute';
      this.neuesSchuljahrOperation.status = 'pending';
      this.neuesSchuljahrFehler = '';
      this.neuesSchuljahr_loading = true;
      if (!this.neuesSchuljahrOperationSpeichern()) {
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahr_loading = false;
        this.neuesSchuljahrFehler = 'Der Vorgang konnte nicht sicher für eine Wiederaufnahme '
          + 'gespeichert werden und wurde deshalb nicht gestartet.';
        return;
      }
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage('execute', operationId, true);
        if (this.neuesSchuljahrWirdZerstoert) return;
        this.neuesSchuljahrAntwortUebernehmen(ergebnis, operationId);
        this.neuesSchuljahrOperationStatusAuswerten();
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        if (error.serverAntwort && error.serverAntwort.operation) {
          try {
            this.neuesSchuljahrAntwortUebernehmen(error.serverAntwort, operationId);
            this.neuesSchuljahrOperationStatusAuswerten();
          } catch (statusFehler) {
            this.neuesSchuljahrFehler = statusFehler.message;
          }
        }
        if (error.serverAntwort) {
          this.neuesSchuljahrPollingStoppen();
          this.neuesSchuljahrAusfuehrungGestartet = false;
          this.neuesSchuljahrVorschau = null;
          this.neuesSchuljahrBestaetigt = false;
          this.neuesSchuljahrOperationLoeschen();
          this.neuesSchuljahrOperation = leereSchuljahrOperation();
          this.neuesSchuljahrFehler = error.message
            || 'Der Server hat den Schuljahreswechsel abgelehnt.';
          return;
        }
        this.neuesSchuljahrFehler = `${error.message || 'Die Serverantwort ist ausgeblieben.'} `
          + 'Der Vorgang wird nicht erneut gesendet; sein Status wird geprüft.';
        this.neuesSchuljahrOperationSpeichern();
        this.neuesSchuljahrPollingPlanen(SCHULJAHR_POLLING_START);
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) this.neuesSchuljahr_loading = false;
      }
    },
    neuesSchuljahrOperationStatusAuswerten() {
      const status = this.neuesSchuljahrOperation.status;
      if (this.neuesSchuljahrAusfuehrungsart === 'execute' && status === 'completed') {
        this.neuesSchuljahrAusfuehrungAbschliessen();
        return;
      }
      if (this.neuesSchuljahrAusfuehrungsart === 'restore' && status === 'restored') {
        this.neuesSchuljahrRestoreAbschliessen();
        return;
      }
      if (['failed', 'error', 'rejected', 'cancelled'].includes(status)) {
        this.neuesSchuljahrPollingStoppen();
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahrRestoreLoading = false;
        const meldung = `Der Server meldet den Vorgangsstatus „${this.neuesSchuljahrStatusText}“.`;
        if (this.neuesSchuljahrAusfuehrungsart === 'restore') {
          this.neuesSchuljahrRestoreFehler = meldung;
        } else {
          this.neuesSchuljahrFehler = meldung;
          this.neuesSchuljahrVorschau = null;
          this.neuesSchuljahrBestaetigt = false;
        }
        this.neuesSchuljahrOperationLoeschen();
        this.neuesSchuljahrOperation = leereSchuljahrOperation();
        return;
      }
      const ausfuehrungNichtGestartet = this.neuesSchuljahrAusfuehrungsart === 'execute'
        && status === 'prepared'
        && !this.neuesSchuljahrOperation.started
        && !this.neuesSchuljahrOperation.serverActive;
      const restoreNichtGestartet = this.neuesSchuljahrAusfuehrungsart === 'restore'
        && status === 'completed'
        && !this.neuesSchuljahrOperation.restoreStarted
        && !this.neuesSchuljahrOperation.serverActive;
      if (ausfuehrungNichtGestartet || restoreNichtGestartet) {
        this.neuesSchuljahrPollingStoppen();
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahrRestoreLoading = false;
        if (restoreNichtGestartet) {
          this.neuesSchuljahrRestoreFehler = 'Die Wiederherstellungsanfrage hat den Server nicht '
            + 'erreicht. Es wurden keine Daten geändert; Sie können denselben Vorgang erneut starten.';
        } else {
          this.neuesSchuljahrFehler = 'Die Ausführungsanfrage hat den Server nicht erreicht. '
            + 'Es wurden keine Daten geändert; Sie können denselben geprüften Vorgang erneut starten.';
        }
        this.neuesSchuljahrOperationSpeichern();
        return;
      }
      if (this.neuesSchuljahrAusfuehrungGestartet) this.neuesSchuljahrPollingPlanen();
    },
    neuesSchuljahrPollingPlanen(verzoegerung = 0) {
      this.neuesSchuljahrPollingStoppen();
      if (this.neuesSchuljahrWirdZerstoert
        || !this.neuesSchuljahrAusfuehrungGestartet
        || !this.neuesSchuljahrOperation.id) return;
      const wartezeit = verzoegerung || Math.min(
        SCHULJAHR_POLLING_MAX,
        SCHULJAHR_POLLING_START * (2 ** Math.min(this.neuesSchuljahrPollVersuch, 3)),
      );
      this.neuesSchuljahrPollTimer = window.setTimeout(() => {
        this.neuesSchuljahrStatusPruefen();
      }, wartezeit);
    },
    neuesSchuljahrPollingStoppen() {
      if (this.neuesSchuljahrPollTimer !== null) {
        window.clearTimeout(this.neuesSchuljahrPollTimer);
        this.neuesSchuljahrPollTimer = null;
      }
    },
    async neuesSchuljahrStatusPruefen() {
      this.neuesSchuljahrPollingStoppen();
      if (this.neuesSchuljahrStatusLoading
        || !this.neuesSchuljahrAusfuehrungGestartet
        || !this.neuesSchuljahrOperation.id) return;
      const operationId = this.neuesSchuljahrOperation.id;
      this.neuesSchuljahrStatusLoading = true;
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage('status', operationId);
        if (this.neuesSchuljahrWirdZerstoert) return;
        this.neuesSchuljahrAntwortUebernehmen(ergebnis, operationId);
        this.neuesSchuljahrPollVersuch = 0;
        this.neuesSchuljahrOperationStatusAuswerten();
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        if (error.serverAntwort) {
          this.neuesSchuljahrAusfuehrungGestartet = false;
          this.neuesSchuljahrRestoreLoading = false;
          this.neuesSchuljahrOperationLoeschen();
          this.neuesSchuljahrOperation = leereSchuljahrOperation();
          const meldung = error.message || 'Der Vorgang ist auf dem Server nicht mehr vorhanden.';
          if (this.neuesSchuljahrAusfuehrungsart === 'restore') {
            this.neuesSchuljahrRestoreFehler = meldung;
          } else {
            this.neuesSchuljahrFehler = meldung;
            this.neuesSchuljahrVorschau = null;
            this.neuesSchuljahrBestaetigt = false;
          }
          return;
        }
        this.neuesSchuljahrPollVersuch += 1;
        const meldung = error.message || 'Der Vorgangsstatus konnte nicht geladen werden.';
        if (this.neuesSchuljahrAusfuehrungsart === 'restore') {
          this.neuesSchuljahrRestoreFehler = `${meldung} Die Statusprüfung wird fortgesetzt.`;
        } else {
          this.neuesSchuljahrFehler = `${meldung} Die Statusprüfung wird fortgesetzt.`;
        }
        this.neuesSchuljahrPollingPlanen();
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) this.neuesSchuljahrStatusLoading = false;
      }
    },
    async neuesSchuljahrAusfuehrungAbschliessen() {
      if (this.neuesSchuljahrAbschlussVerarbeitet) return;
      this.neuesSchuljahrAbschlussVerarbeitet = true;
      this.neuesSchuljahrPollingStoppen();
      this.neuesSchuljahrFehler = '';
      this.neuesSchuljahrOperationLoeschen();
      try {
        window.localStorage.removeItem(SCHULJAHR_ENTWURF_SPEICHERKEY);
        window.localStorage.removeItem(SCHULJAHR_ENTWURF_SPEICHERKEY_LEGACY);
      } catch (error) {
        // Der bestätigte Serverabschluss bleibt davon unberührt.
      }
      this.$emit('schuljahrAbgeschlossen');
      await this.neuestesWiederherstellbaresSchuljahrLaden();
      if (!this.neuesSchuljahrWirdZerstoert) {
        this.$store.commit('main/alert', {
          typ: 'success',
          text: 'Der Schuljahreswechsel wurde abgeschlossen und die Daten wurden neu geladen.',
        }, { root: true });
      }
    },
    async neuestesWiederherstellbaresSchuljahrLaden() {
      if (this.neuesSchuljahrLatestLoading || this.neuesSchuljahrWirdZerstoert) return;
      this.neuesSchuljahrLatestLoading = true;
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage('latest');
        const letzter = ergebnis.latestRestorable;
        const quelle = letzter && letzter.operation ? letzter.operation : letzter;
        const operation = this.neuesSchuljahrOperationNormalisieren(quelle);
        this.neuestesWiederherstellbaresSchuljahr = operation.id && operation.restorable
          ? { ...letzter, ...operation } : null;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        this.neuestesWiederherstellbaresSchuljahr = null;
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) this.neuesSchuljahrLatestLoading = false;
      }
    },
    async neuesSchuljahrElternRecoveryDialogOeffnen() {
      if (!this.neuesSchuljahrElternRecoveryErlaubt) return;
      this.dialog_neuesSchuljahrElternRecovery = true;
      this.neuesSchuljahrElternRecoveryErfolgreich = false;
      this.neuesSchuljahrElternRecoveryBestaetigt = false;
      this.neuesSchuljahrElternRecoveryFehler = '';
      await this.neuesSchuljahrElternRecoveryVorschauLaden();
    },
    neuesSchuljahrElternRecoveryDialogSchliessen() {
      if (this.neuesSchuljahrElternRecoveryLoading
        || this.neuesSchuljahrElternRecoveryPreviewLoading) return;
      this.dialog_neuesSchuljahrElternRecovery = false;
      this.neuesSchuljahrElternRecoveryBestaetigt = false;
      this.neuesSchuljahrElternRecoveryFehler = '';
      this.neuesSchuljahrElternRecoveryVorschau = null;
      this.neuesSchuljahrElternRecoveryErfolgreich = false;
    },
    async neuesSchuljahrElternRecoveryVorschauLaden() {
      if (!this.neuesSchuljahrElternRecoveryErlaubt
        || this.neuesSchuljahrElternRecoveryPreviewLoading
        || this.neuesSchuljahrElternRecoveryLoading) return;
      this.neuesSchuljahrElternRecoveryPreviewLoading = true;
      this.neuesSchuljahrElternRecoveryBestaetigt = false;
      this.neuesSchuljahrElternRecoveryFehler = '';
      this.neuesSchuljahrElternRecoveryVorschau = null;
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage('recoverParentsPreview');
        const vorschau = ergebnis && ergebnis.recoveryPreview;
        const operation = ergebnis && ergebnis.operation;
        if (!vorschau || typeof vorschau !== 'object'
          || !operation || typeof operation !== 'object'
          || !SCHULJAHR_OPERATION_ID.test(String(vorschau.operationId || ''))
          || String(operation.id || '') !== String(vorschau.operationId || '')
          || !SCHULJAHR_HASH.test(String(vorschau.previewHash || ''))
          || !vorschau.counts || typeof vorschau.counts !== 'object') {
          throw new Error('Der Server hat keine vollständige, bestätigbare Recovery-Vorschau geliefert.');
        }
        this.neuesSchuljahrElternRecoveryVorschau = vorschau;
        this.neuesSchuljahrElternRecoveryErfolgreich = Boolean(vorschau.alreadyRecovered);
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        this.neuesSchuljahrElternRecoveryFehler = error.message
          || 'Die Eltern-Wiederherstellung konnte nicht sicher vorbereitet werden.';
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) {
          this.neuesSchuljahrElternRecoveryPreviewLoading = false;
        }
      }
    },
    async neuesSchuljahrElternWiederherstellen() {
      const vorschau = this.neuesSchuljahrElternRecoveryVorschau;
      if (!this.neuesSchuljahrElternRecoveryErlaubt
        || !this.neuesSchuljahrElternRecoveryBestaetigt
        || this.neuesSchuljahrElternRecoveryLoading
        || !vorschau
        || !SCHULJAHR_OPERATION_ID.test(String(vorschau.operationId || ''))
        || !SCHULJAHR_HASH.test(String(vorschau.previewHash || ''))) return;
      this.neuesSchuljahrElternRecoveryLoading = true;
      this.neuesSchuljahrElternRecoveryFehler = '';
      try {
        const ergebnis = await this.neuesSchuljahrApiAnfrage(
          'recoverParents',
          String(vorschau.operationId),
          false,
          { preview_hash: String(vorschau.previewHash) },
        );
        if (!ergebnis.recovery || typeof ergebnis.recovery !== 'object') {
          throw new Error('Der Server hat den Recovery-Abschluss nicht vollständig bestätigt.');
        }
        this.neuesSchuljahrElternRecoveryErfolgreich = true;
        this.neuesSchuljahrElternRecoveryBestaetigt = false;
        this.$set(this.neuesSchuljahrElternRecoveryVorschau, 'alreadyRecovered', true);
        if (ergebnis.recovery.counts && typeof ergebnis.recovery.counts === 'object') {
          this.$set(
            this.neuesSchuljahrElternRecoveryVorschau,
            'counts',
            ergebnis.recovery.counts,
          );
        }
        try {
          window.localStorage.removeItem('f200');
        } catch (error) {
          // Der bestaetigte Serverabschluss bleibt davon unberuehrt.
        }
        this.$emit('schuljahrAbgeschlossen');
        this.$store.commit('main/alert', {
          typ: 'success',
          text: 'Die Elternkonten der weiterhin vorhandenen Kinder wurden sicher wiederhergestellt.',
        }, { root: true });
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        this.neuesSchuljahrElternRecoveryFehler = `${error.message
          || 'Die Eltern-Wiederherstellung konnte nicht bestätigt werden.'} `
          + 'Bitte laden Sie die sichere Vorschau erneut; ein bereits abgeschlossener Vorgang wird dabei erkannt.';
      } finally {
        if (!this.neuesSchuljahrWirdZerstoert) {
          this.neuesSchuljahrElternRecoveryLoading = false;
        }
      }
    },
    neuesSchuljahrRestoreDialogOeffnen() {
      if (!this.neuestesWiederherstellbaresSchuljahr) return;
      this.neuesSchuljahrRestoreOperationId = String(
        this.neuestesWiederherstellbaresSchuljahr.id || '',
      );
      this.neuesSchuljahrRestoreBestaetigt = false;
      this.neuesSchuljahrRestoreFehler = '';
      this.dialog_neuesSchuljahrRestore = true;
    },
    neuesSchuljahrRestoreDialogSchliessen() {
      if (this.neuesSchuljahrRestoreLoading) return;
      this.dialog_neuesSchuljahrRestore = false;
      this.neuesSchuljahrRestoreBestaetigt = false;
      this.neuesSchuljahrRestoreFehler = '';
      this.neuesSchuljahrRestoreOperationId = '';
    },
    async neuesSchuljahrWiederherstellen() {
      if (!this.neuesSchuljahrRestoreBestaetigt
        || this.neuesSchuljahrRestoreLoading
        || !SCHULJAHR_OPERATION_ID.test(this.neuesSchuljahrRestoreOperationId)) return;
      this.neuesSchuljahrOperation = this.neuesSchuljahrOperationNormalisieren(
        this.neuestesWiederherstellbaresSchuljahr,
        this.neuesSchuljahrRestoreOperationId,
      );
      this.neuesSchuljahrAusfuehrungsart = 'restore';
      this.neuesSchuljahrAusfuehrungGestartet = true;
      this.neuesSchuljahrRestoreLoading = true;
      this.neuesSchuljahrRestoreFehler = '';
      if (!this.neuesSchuljahrOperationSpeichern()) {
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahrRestoreLoading = false;
        this.neuesSchuljahrRestoreFehler = 'Der sichere Wiederaufnahmestatus konnte nicht '
          + 'gespeichert werden. Die Wiederherstellung wurde nicht gestartet.';
        return;
      }
      try {
        const operationId = this.neuesSchuljahrOperation.id;
        const ergebnis = await this.neuesSchuljahrApiAnfrage('restore', operationId);
        if (this.neuesSchuljahrWirdZerstoert) return;
        this.neuesSchuljahrAntwortUebernehmen(ergebnis, operationId);
        this.neuesSchuljahrOperationStatusAuswerten();
      } catch (error) {
        if (this.neuesSchuljahrWirdZerstoert
          || (error && error.name === 'AbortError')) return;
        if (error.serverAntwort && error.serverAntwort.operation) {
          try {
            this.neuesSchuljahrAntwortUebernehmen(
              error.serverAntwort,
              this.neuesSchuljahrOperation.id,
            );
            this.neuesSchuljahrOperationStatusAuswerten();
          } catch (statusFehler) {
            this.neuesSchuljahrRestoreFehler = statusFehler.message;
          }
        }
        if (error.serverAntwort) {
          this.neuesSchuljahrPollingStoppen();
          this.neuesSchuljahrAusfuehrungGestartet = false;
          this.neuesSchuljahrRestoreLoading = false;
          this.neuesSchuljahrOperationLoeschen();
          this.neuesSchuljahrOperation = leereSchuljahrOperation();
          this.neuesSchuljahrRestoreFehler = error.message
            || 'Der Server hat die Wiederherstellung abgelehnt.';
          return;
        }
        this.neuesSchuljahrRestoreFehler = `${error.message
          || 'Die Serverantwort ist ausgeblieben.'} Der Status wird geprüft.`;
        this.neuesSchuljahrOperationSpeichern();
        this.neuesSchuljahrPollingPlanen(SCHULJAHR_POLLING_START);
      }
    },
    neuesSchuljahrRestoreAbschliessen() {
      this.neuesSchuljahrPollingStoppen();
      this.neuesSchuljahrRestoreFehler = '';
      this.neuesSchuljahrOperationLoeschen();
      try {
        window.localStorage.removeItem('f200');
        window.localStorage.removeItem(SCHULJAHR_ENTWURF_SPEICHERKEY);
        window.localStorage.removeItem(SCHULJAHR_ENTWURF_SPEICHERKEY_LEGACY);
      } catch (error) {
        // backendErrorSession leert anschließend den gesamten lokalen Sitzungszustand.
      }
      window.setTimeout(() => {
        this.$store.commit('login/backendErrorSession');
      }, 800);
    },
    neuesSchuljahrDialogGeoeffnet() {
      if (this.neuesSchuljahrAusfuehrungGestartet) return;
      if (this.neuesSchuljahrStatus.schritt === this.neuesSchuljahrAnzahlSchritte
        && !this.neuesSchuljahrVorschau) this.neuesSchuljahrPreflight();
      this.neuestesWiederherstellbaresSchuljahrLaden();
    },
    neuesSchuljahrDialogSchliessen() {
      if (this.neuesSchuljahrDialogGesperrt) return;
      this.dialog_neuesSchuljahr = false;
      if (this.neuesSchuljahrOperationAbgeschlossen) {
        this.neuesSchuljahrStatus = standardSchuljahrStatus();
        this.neuesSchuljahrVorschau = null;
        this.neuesSchuljahrOperation = leereSchuljahrOperation();
        this.neuesSchuljahrAusfuehrungGestartet = false;
        this.neuesSchuljahrAusfuehrungsart = '';
        this.neuesSchuljahrBestaetigt = false;
        this.neuesSchuljahrAbschlussVerarbeitet = false;
      }
    },
    datumFormatieren(wert) {
      if (!wert) return 'unbekannt';
      let normalisiert = wert;
      if ((typeof wert === 'number' || /^\d+$/.test(String(wert)))
        && Number.isFinite(Number(wert))) {
        const epoch = Number(wert);
        normalisiert = epoch < 1000000000000 ? epoch * 1000 : epoch;
      } else if (typeof wert === 'string' && /^\d{4}-\d{2}-\d{2} /.test(wert)) {
        normalisiert = wert.replace(' ', 'T');
      }
      const datum = new Date(normalisiert);
      if (Number.isNaN(datum.getTime())) return String(wert);
      return new Intl.DateTimeFormat('de-DE', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(datum);
    },
    neuesSchuljahrOnline() {
      if (this.neuesSchuljahrAusfuehrungGestartet) {
        this.neuesSchuljahrStatusPruefen();
      } else {
        this.neuestesWiederherstellbaresSchuljahrLaden();
      }
    },
    automatischeKlassenzuweisungBeiSchuljahreswechsel() {
      this.prop_klassen.forEach((k) => {
        const stufe = parseInt(k.name, 10);
        const neueStufe = stufe + 1;
        const ohneStufe = k.name.split(stufe).join('');
        if (Number.isFinite(stufe)
          && this.prop_klassen.filter((o) => o.name === `${neueStufe}${ohneStufe}`).length > 0) {
          // theoretisch nächste Klasse gefunden
          this.$set(
            this.neuesSchuljahrStatus.naechsteKlasse,
            k.id,
            this.prop_klassen.filter((o) => o.name === `${neueStufe}${ohneStufe}`)[0].id,
          );
        } else if (k.name.toLowerCase().includes('neu')) {
          // theoretisch KEINE nächste Klasse gefunden
          // Da neu im Namen, weise sich selbst zu
          this.$set(this.neuesSchuljahrStatus.naechsteKlasse, k.id, k.id);
        } else {
          // Kein eindeutiges Ziel: bewusst offen lassen. Eine Löschung darf nicht
          // allein aus einem Klassennamen abgeleitet werden.
          this.$delete(this.neuesSchuljahrStatus.naechsteKlasse, k.id);
        }
      });
      this.neuesSchuljahrMappingPruefungAnzeigen = true;
      this.neuesSchuljahrEntwurfSpeichern();
    },
    resetAutomatischeKlassenzuweisungBeiSchuljahreswechsel() {
      this.neuesSchuljahrStatus.naechsteKlasse = {};
      this.neuesSchuljahrMappingPruefungAnzeigen = false;
      this.neuesSchuljahrEntwurfSpeichern();
    },
  },
  created() {
    this.xDeleted = JSON.parse(JSON.stringify(this.save));
    this.datenLaden();
    this.neuesSchuljahrEntwurfLaden();
    this.neuesSchuljahrOperationWiederaufnehmen();
    this.neuestesWiederherstellbaresSchuljahrLaden();
    window.addEventListener('online', this.neuesSchuljahrOnline);
  },
  beforeDestroy() {
    this.neuesSchuljahrWirdZerstoert = true;
    this.neuesSchuljahrPollingStoppen();
    this.neuesSchuljahrController.forEach((controller) => controller.abort());
    this.neuesSchuljahrController = [];
    window.removeEventListener('online', this.neuesSchuljahrOnline);
  },
};
</script>
